import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const Slide10Parents: React.FC = () => {
  const features = [
    'Real-time progress updates',
    'Achievement notifications',
    'Struggle alerts',
    'Direct teacher messaging',
    'Learning schedule visibility',
  ];

  const comparisons = [
    { feature: 'Availability', us: '24/7', them: 'Scheduled sessions' },
    { feature: 'Subjects', us: 'All subjects', them: 'Single subject' },
    { feature: 'Cost', us: 'Fraction of cost', them: '$50-100/hour' },
    { feature: 'Memory', us: 'AI remembers struggles', them: 'Starts fresh' },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-4 text-center"
      >
        Parents Stay Informed
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-2xl text-[#94a3b8] mb-10 text-center"
      >
        Complete transparency into their child's learning journey
      </motion.p>

      <div className="flex gap-10 max-w-5xl w-full">
        {/* Left: Features */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
          className="flex-1"
        >
          <h3 className="text-2xl font-semibold text-white mb-6">What Parents Get</h3>
          <div className="space-y-4">
            {features.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 + i * 0.08 }}
                className="flex items-center gap-4 p-4 rounded-xl"
                style={{
                  background: 'rgba(236, 72, 153, 0.1)',
                  border: '1px solid rgba(236, 72, 153, 0.3)',
                }}
              >
                <CheckCircleIcon className="w-7 h-7 text-[#ec4899] flex-shrink-0" />
                <span className="text-xl text-white">{item}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Right: vs Tutoring */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4 }}
          className="flex-1 rounded-xl p-6"
          style={{
            background: 'rgba(30, 41, 59, 0.5)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <h3 className="text-2xl font-semibold text-white mb-6">Better Than Tutoring</h3>
          <div className="space-y-4">
            {comparisons.map((item, i) => (
              <div key={i} className="flex items-center justify-between py-3 border-b border-[#1e293b] last:border-0">
                <span className="text-lg text-[#94a3b8]">{item.feature}</span>
                <div className="flex items-center gap-6">
                  <span className="text-lg font-semibold text-[#10b981]">{item.us}</span>
                  <span className="text-sm text-[#64748b]">vs</span>
                  <span className="text-lg text-[#64748b]">{item.them}</span>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Slide10Parents;
